import styled from 'styled-components';

const ServiceAccountEntry = styled.div({
  paddingLeft: 8,
  paddingRight: 4,
  paddingTop: 8,
  paddingBottom: 8,
});

const ServiceAccountKeyEntry = styled.div({
  paddingLeft: 32,
  paddingRight: 4,
  paddingTop: 8,
  paddingBottom: 8,
  borderTop: '1px solid var(--color-border, #e5e7eb)',
});

export { ServiceAccountEntry, ServiceAccountKeyEntry };
